import React from 'react';
import img1 from '@src/assets/planets/planet-1.svg';
import img2 from '@src/assets/planets/planet-2.svg';
import img4 from '@src/assets/planets/planet-4.svg';
import img5 from '@src/assets/planets/planet-5.svg';
import logo from '@src/assets/logo/vbeeAI.svg';
import { StyledPanel } from './index.styled';

const Panel = () => (
  <StyledPanel>
    <div className="container">
      <div className="hero-circle">
        <img className="inner-img" src={logo} alt="" />

        {/* Vòng 1 */}
        <div className="hero-rotate circle-1">
          <div className="planet planet-1-circle1">
            <img src={img2} alt="" />
          </div>
          <div className="planet planet-2-circle1">
            <img src={img4} alt="" />
          </div>
        </div>

        {/* Vòng 2 */}
        <div className="hero-rotate circle-2">
          <div className="planet planet-1-circle2">
            <img src={img1} alt="" />
          </div>
          <div className="planet planet-3-circle2">
            <img src={img5} alt="" />
          </div>
        </div>

        {/* Vòng 3 */}
        <div className="hero-rotate circle-3" />
        <div className="hero-rotate circle-4" />
      </div>
    </div>
  </StyledPanel>
);

export default Panel;
